import { useEffect, useState } from 'react';
import { useAuthStore } from '../lib/store';
import { listClips, type Clip } from '../lib/api';
import { Link } from 'react-router-dom';

export default function ClipsPage() {
  const { user } = useAuthStore();
  const [clips, setClips] = useState<Clip[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      loadClips();
    }
  }, [user]);

  const loadClips = async () => {
    try {
      const data = await listClips(user!.id);
      setClips(data.clips);
    } catch (error) {
      console.error('Error loading clips:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <h1 className="text-2xl font-bold text-slate-800">Klipu Zote</h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200">
          {loading ? (
            <div className="p-6 text-center text-slate-500">Inapakia...</div>
          ) : clips.length === 0 ? (
            <div className="p-6 text-center text-slate-500">Hakuna klipu bado</div>
          ) : (
            <div className="divide-y divide-slate-200">
              {clips.map((clip) => (
                <Link
                  key={clip.id}
                  to={`/approval/${clip.id}`}
                  className="block px-6 py-4 hover:bg-slate-50 transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <h3 className="font-medium text-slate-800">{clip.title}</h3>
                      <p className="text-sm text-slate-500 mt-1 line-clamp-2">
                        {clip.transcript}
                      </p>
                      <div className="flex items-center gap-4 mt-2">
                        <span className="text-xs text-slate-500">
                          Duration: {clip.duration.toFixed(1)}s
                        </span>
                        <span className="text-xs text-slate-500">
                          Score: {clip.virality_score}
                        </span>
                        {clip.sentiment && (
                          <span className={`text-xs px-2 py-1 rounded-full ${
                            clip.sentiment === 'positive'
                              ? 'bg-green-100 text-green-700'
                              : clip.sentiment === 'negative'
                              ? 'bg-red-100 text-red-700'
                              : 'bg-slate-100 text-slate-700'
                          }`}>
                            {clip.sentiment}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="ml-4">
                      {clip.pa_approved === 1 ? (
                        <span className="px-3 py-1 bg-green-100 text-green-700 text-sm rounded-full">
                          Approved
                        </span>
                      ) : (
                        <span className="px-3 py-1 bg-orange-100 text-orange-700 text-sm rounded-full">
                          Pending
                        </span>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
